import { DOCS_URL } from '@constants/constant';
import { MessageCodes } from './enum/common';
import { IndexingStatusMessages, PipelineStatusCodes } from './pipelines';

export const OVERVIEW_TAB_LABEL = 'Overview';
export const LOGS_TAB_LABEL = 'Logs';
export const SETTINGS_TAB_LABEL = 'Settings';
export const ACTIVATE_PIPELINE_BUTTON_LABEL = 'Activate';
export const DOCUMENTATION_LINK = 'documentation';
export const LOGS_LINK = 'logs';
export const EMPTY_LOGS_UNDEPLOYED_PIPELINE_LABEL = `There aren’t any logs for this pipeline yet. Once deployed, you will be able to view all logs.`;
export const EMPTY_LOGS_DEPLOYED_PIPELINE_LABEL = `There are no logs for this pipeline. This is either because there was nothing to log or this pipeline was deployed more than two days ago. We keep logs for the last two days or since the last deployment, whichever is latest.`;
export const EMPTY_LOGS_WITH_FILTERS_LABEL = `There aren't any logs for your filters. Change or clear the filters.`;
export const EMPTY_LOGS_WITH_SEARCH_VALUE_LABEL = `There aren't any logs for your search. Change or clear the search.`;
export const SETTINGS_FEEDBACK_TAGS_TITLE = 'Feedback tags';
export const SETTINGS_FEEDBACK_TAGS_DESCRIPTION =
  'Add feedback tags that you find relevant for the use-case. The tags added here, will be available to be selected when providing feedback on an answer.';
export const SETTINGS_FEEDBACK_TAGS_LABEL = 'Tags';

export enum PipelineDetailsTabsKeys {
  OVERVIEW = 'overview',
  LOGS = 'logs',
  SETTINGS = 'settings',
}

export interface IPipelineStatusMessage {
  status: string;
  documentation?: string;
  type: MessageCodes;
  title: string;
  message: string;
}

export const FETCH_PIPELINE_LOGS_LIMIT = 20;

const PIPELINE_DEPLOYMENT_TROUBLESHOOTING_DOCS_URL = `${DOCS_URL}docs/troubleshooting-pipeline-deployment`;

export const PIPELINE_STATUS_MESSAGES: IPipelineStatusMessage[] = [
  {
    status: PipelineStatusCodes.DEPLOYMENT_FAILED,
    documentation: PIPELINE_DEPLOYMENT_TROUBLESHOOTING_DOCS_URL,
    type: MessageCodes.ERROR,
    title: 'Pipeline failed to deploy',
    message:
      'There could be multiple reasons that caused the deployment of your pipeline to fail. Check out our %documentation% for step by step troubleshooting.',
  },
  {
    status: 'Unhealthy', // TODO: Standardize the status labels
    documentation: PIPELINE_DEPLOYMENT_TROUBLESHOOTING_DOCS_URL,
    type: MessageCodes.WARNING,
    title: 'Your pipeline is unhealthy',
    message: `Wait a couple of seconds for this issue to resolve. If a pipeline takes longer than 2 seconds to respond, it becomes unhealthy. It's a temporary state caused by high load or other temporary problems. You don't need to take any action.`,
  },
  {
    status: IndexingStatusMessages.FAILED_INDEXING,
    documentation: PIPELINE_DEPLOYMENT_TROUBLESHOOTING_DOCS_URL,
    type: MessageCodes.ERROR,
    title: `Your pipeline didn't deploy`,
    message: `Wait a couple of seconds and try again. If it doesn't deploy, check our %documentation% to learn how to resolve it.`,
  },
  {
    status: PipelineStatusCodes.IDLE,
    type: MessageCodes.INFO,
    title: `This pipeline is on standby`,
    message: `Unused pipelines automatically enter standby mode after %idleTimeout% to save resources. Your data is still there, secure and accessible. %activate% the pipeline to use it.`,
  },
];
